var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpendo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_2",
    "data-name": "Livello 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150.51 110.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-1, .cls-3 {\n        stroke: #000;\n        stroke-width: 2px;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        stroke: #fff;\n        stroke-width: 5px;\n      }\n\n      .cls-3 {\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M75.26,107.68c22.41,0,40.58-18.17,40.58-40.58H34.67c0,22.41,18.17,40.58,40.58,40.58h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2.51,
    y: 2.5,
    width: 32.17,
    height: 64.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 115.83,
    y: 2.5,
    width: 32.17,
    height: 64.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M75.26,107.68c22.41,0,40.58-18.17,40.58-40.58H34.67c0,22.41,18.17,40.58,40.58,40.58h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2.51,
    y: 2.5,
    width: 32.17,
    height: 64.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 115.83,
    y: 2.5,
    width: 32.17,
    height: 64.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75.26,107.68c22.41,0,40.58-18.17,40.58-40.58H34.67c0,22.41,18.17,40.58,40.58,40.58h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.51,
    y: 2.5,
    width: 32.17,
    height: 64.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 115.83,
    y: 2.5,
    width: 32.17,
    height: 64.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M75.26,107.68c22.41,0,40.58-18.17,40.58-40.58H34.67c0,22.41,18.17,40.58,40.58,40.58h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.51,
    y: 2.5,
    width: 32.17,
    height: 64.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 115.83,
    y: 2.5,
    width: 32.17,
    height: 64.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpendo);
export default __webpack_public_path__ + "static/media/Upendo.8b20067a3a9832d1cfecacfa6b618607.svg";
export { ForwardRef as ReactComponent };